import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { SuketBaseWithRelationship, SuketGadarContentInterface } from "@/types/suket_gawat_darurat";
import SvcSuketGawatDarurat from "@/services/SuketGawatDarurat";
import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";

@Module({ dynamic: true, namespaced: true, store, name: "suket-gawat-darurat" })
class SuketGawatDarurat extends VuexModule {
  suket: SuketBaseWithRelationship<SuketGadarContentInterface> = null;
  loading = false;

  get pasien(): any {
    return storePasien.identitasPasien;
  }

  get register(): any {
    return RegisterKunjungan.register;
  }

  @Mutation
  SET_SUKET(suket: SuketBaseWithRelationship<SuketGadarContentInterface>) {
    this.suket = suket;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async fetchSuketByRegister(): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketGawatDarurat.getByRegister(
      this.register.no
    ).finally(() => {
      this.SET_LOADING(false);
    });

    // const response = suketArray.data.length ? suketArray[0] : null;
    this.SET_SUKET(suketArray.data.length ? suketArray.data[0] : null);
  }

  @Action({ rawError: true })
  async getSuketByRegister(noReg): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketGawatDarurat.getByRegister(noReg).finally(
      () => {
        this.context.commit("SET_LOADING", false);
      }
    );

    this.SET_SUKET(suketArray.data.length ? suketArray.data[0] : null);
  }

  @Action reset() {
    this.SET_SUKET(null);
  }
}

export default getModule(SuketGawatDarurat);
